import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNeonCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 87,
	height: 87,
	viewBox: "0 0 87 87",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 43.4999,
		cy: 43.8301,
		r: 41.8495,
		stroke: "#A7C4FC",
		strokeWidth: 2,
		strokeDasharray: "6 6"
	})
});
export default SvgNeonCircle;
